import { noticesConstants } from '../constants';

export const noticesActions = {
    getAllNotices: () => ({ type: noticesConstants.NOTICES_GETALL_REQUEST }),
    getNoticeById: (id) => ({ type: noticesConstants.NOTICES_GETBYID_REQUEST, id })
};